import type { FeatureHintStep } from 'components/shared/feature-hints';

import { MARK_FLOATING_BUTTON_HINT_ID } from 'containers/admin/clients/client/tabs-components/ai-assistant/mark-panel/mark-panel.constants';

export const MONITORING_HINT_ID = {
  displayOptions: 'monitoring-display-options',
  displayOptionsPanel: 'monitoring-display-options-panel',
  funnelDisplayMode: 'monitoring-funnel-display-mode',
  extendWith: 'monitoring-extend-with',
  criticalElementRow: 'monitoring-critical-element-row',
  criticalElementDisplayMode: 'monitoring-critical-element-display-mode',
  askMark: MARK_FLOATING_BUTTON_HINT_ID,
} as const satisfies Record<string, string>;

export const MONITORING_HINTS_STEPS: FeatureHintStep[] = [
  {
    id: MONITORING_HINT_ID.displayOptions,
    tooltipAnchorId: MONITORING_HINT_ID.displayOptionsPanel,
    title: 'Display options',
    body: "Use Display options to choose the time period you're comparing against, and to control which cohorts appear alongside your own data.",
    placement: 'left-start',
    ringClassName: 'rounded-md',
  },
  {
    id: MONITORING_HINT_ID.funnelDisplayMode,
    title: 'Volume/Rate toggle',
    body: 'Switch between Volume and Rate to view each funnel stage as raw counts or as conversion percentages, whichever tells the clearer story for your class.',
    placement: 'left-start',
    ringClassName: 'rounded-md',
  },
  {
    id: MONITORING_HINT_ID.extendWith,
    title: 'Extend with (Prospect View, Financial Aid View, Retention View)',
    body: 'Pull in Prospect View, Financial Aid View, or Retention View to show additional funnels steps without leaving the page.',
    placement: 'right-start',
    ringClassName: 'rounded-md',
  },
  {
    id: MONITORING_HINT_ID.criticalElementRow,
    title: 'Critical Element row',
    body: 'Each Critical Element breaks the funnel down by the populations that matter most to your class, so you can see how a specific segment is tracking, not just your totals.',
    placement: 'top',
    ringClassName: 'rounded-[10px]',
  },
  {
    id: MONITORING_HINT_ID.criticalElementDisplayMode,
    title: 'Volume/Rate/Proportion toggle',
    body: 'Switch between Volume, Rate, and Proportion to view your Critical Elements as raw counts, conversion percentages, or share of your total funnel.',
    placement: 'left-start',
    ringClassName: 'rounded-md',
  },
  {
    id: MONITORING_HINT_ID.askMark,
    title: 'Ask MARK',
    body: "Ask MARK questions about what you're seeing right on this page, from how a Critical Element moved to showing how your cohort comparison breaks down, and get answers without leaving Monitoring.",
    placement: 'right-end',
    ringClassName: 'rounded-full animate-none',
  },
];

export const MONITORING_START_HINTS_EVENT = 'monitoring-hints:start';

export const dispatchMonitoringStartHints = (): void => {
  window.dispatchEvent(new Event(MONITORING_START_HINTS_EVENT));
};
